const func = $target => {
	window.loader.key('rangeSlider', function() {
		var $parent = $target.parent();
		$target.ionRangeSlider({
			onStart: function (data) {
				$parent.addClass('show');
			},
			onFinish: function(data) {
				var found = false;

				$.each(window.uri.segment(), function(i){
					if (this.indexOf('price=') != -1) {
						if (data.from == $target.data('min') && data.to == $target.data('max')) {
							window.uri.segment(i,'');
						} else {
							window.uri.segment(i, 'price='+data.from+','+data.to);
						}
						found = true;
					}
				})

				if (found === false) {
					window.uri.segment('price='+data.from+','+data.to);
				}

				document.location = window.uri.href();
			},
			skin: "round"
		});
	});
};

export default func;
